// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.recordingNavBar {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #1faeff;
    top: 0;
    left: 0;
    width: 100vw;
    height: 75px;
    z-index: 1000;
}

div.recordingNavBar .titleText.small {
    color: #fff;
}

div.recordingNavBar .searchBar.small {
    border: none;
}

div.recordingNavBar .searchButton.small {
    border: 3px solid white;
}

.recordingVerticalLayout {
    align-items: flex-start !important;
    position: relative;
}

@media all and (max-width: 500px) {
    .recordingVerticalLayout {
        width: calc(100vw - 20px);
    }
}

.recordingTagsContainer {
    margin: 5px;
    align-items: center;
}

#Recording {
    position: relative;
    padding-top: 75px;
    min-height: 100%;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
}

#RecordingViewport {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 75px);
    flex-shrink: 0;
}

#RecordingHeaderRow {
    position: relative;
    align-items: flex-end;
    min-height: 68px;
    padding-top: 8px;
    flex-shrink: 0;
}

#RecordingHeaderLeft {
    flex: 1 1;
    padding: 4px 5px 8px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
}

#RecordingHeaderDescription {
    margin: 2px 0 0 -6px;
    padding: 4px 6px;
    font-size: 13px;
    line-height: 1.4;
    color: #000;
    max-width: 700px;
}

#RecordingHeaderDescription.expandable {
    cursor: pointer;
    border-radius: 6px;
    transition: background-color 0.15s ease;
}

#RecordingHeaderDescription.expandable:hover {
    background-color: rgba(0, 0, 0, 0.06);
}

#RecordingHeaderDescriptionToggle {
    border: none;
    background: none;
    padding: 0;
    margin-left: 4px;
    font-size: 13px;
    font-weight: 600;
    color: #888;
    cursor: pointer;
}

#RecordingHeaderDescriptionToggle:hover {
    color: #000;
}

#RecordingHeaderControls {
    flex: 1 1;
    padding: 0 10px 0 5px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 6px;
}

#RecordingHeaderEdit {
    position: fixed;
    top: 83px;
    right: 20px;
    z-index: 60;
}

#RecordingSplit {
    flex: 1 1;
    min-height: 0;
}

#Recording #LeftPanel {
    flex: 1 1;
    height: 100%;
    padding: 10px 5px 0 10px;
    position: relative;
}

#Recording #RightPanel {
    flex: 1 1;
    height: 100%;
    padding: 10px 10px 0 5px;
}

#RecordingTranscriptEditor {
    flex: 1 1;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
}

#RecordingTranscriptEditor a.ml-auto {
    margin-right: 16px;
}

#RecordingTranscriptEditor .transcript-editor {
    max-height: none;
    overflow-y: visible;
}

#RightPanel #transcript {
    width: 100%;
    flex: 1 1;
    overflow: visible;
    margin-bottom: 0 !important;
}

#DropDownContainer {
    position: absolute;
    right: 47px;
    top: 3px;
    padding-bottom: 2px;
    background: #1faeff;
}

#EditButton {
    position: absolute;
    top: 10px;
    right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Magor/Recording/Recording.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAO;IACP,qBAAqB;IACrB,aAAa;IACb,qBAAqB;IACrB,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;AACf;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAO;IACP,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf","sourcesContent":["div.recordingNavBar {\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    background: #1faeff;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 75px;\n    z-index: 1000;\n}\n\ndiv.recordingNavBar .titleText.small {\n    color: #fff;\n}\n\ndiv.recordingNavBar .searchBar.small {\n    border: none;\n}\n\ndiv.recordingNavBar .searchButton.small {\n    border: 3px solid white;\n}\n\n.recordingVerticalLayout {\n    align-items: flex-start !important;\n    position: relative;\n}\n\n@media all and (max-width: 500px) {\n    .recordingVerticalLayout {\n        width: calc(100vw - 20px);\n    }\n}\n\n.recordingTagsContainer {\n    margin: 5px;\n    align-items: center;\n}\n\n#Recording {\n    position: relative;\n    padding-top: 75px;\n    min-height: 100%;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-start;\n}\n\n#RecordingViewport {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 75px);\n    flex-shrink: 0;\n}\n\n#RecordingHeaderRow {\n    position: relative;\n    align-items: flex-end;\n    min-height: 68px;\n    padding-top: 8px;\n    flex-shrink: 0;\n}\n\n#RecordingHeaderLeft {\n    flex: 1;\n    padding: 4px 5px 8px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    min-width: 0;\n}\n\n#RecordingHeaderDescription {\n    margin: 2px 0 0 -6px;\n    padding: 4px 6px;\n    font-size: 13px;\n    line-height: 1.4;\n    color: #000;\n    max-width: 700px;\n}\n\n#RecordingHeaderDescription.expandable {\n    cursor: pointer;\n    border-radius: 6px;\n    transition: background-color 0.15s ease;\n}\n\n#RecordingHeaderDescription.expandable:hover {\n    background-color: rgba(0, 0, 0, 0.06);\n}\n\n#RecordingHeaderDescriptionToggle {\n    border: none;\n    background: none;\n    padding: 0;\n    margin-left: 4px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #888;\n    cursor: pointer;\n}\n\n#RecordingHeaderDescriptionToggle:hover {\n    color: #000;\n}\n\n#RecordingHeaderControls {\n    flex: 1;\n    padding: 0 10px 0 5px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-start;\n    gap: 6px;\n}\n\n#RecordingHeaderEdit {\n    position: fixed;\n    top: 83px;\n    right: 20px;\n    z-index: 60;\n}\n\n#RecordingSplit {\n    flex: 1;\n    min-height: 0;\n}\n\n#Recording #LeftPanel {\n    flex: 1;\n    height: 100%;\n    padding: 10px 5px 0 10px;\n    position: relative;\n}\n\n#Recording #RightPanel {\n    flex: 1;\n    height: 100%;\n    padding: 10px 10px 0 5px;\n}\n\n#RecordingTranscriptEditor {\n    flex: 1;\n    min-height: 0;\n    width: 100%;\n    overflow-y: auto;\n}\n\n#RecordingTranscriptEditor a.ml-auto {\n    margin-right: 16px;\n}\n\n#RecordingTranscriptEditor .transcript-editor {\n    max-height: none;\n    overflow-y: visible;\n}\n\n#RightPanel #transcript {\n    width: 100%;\n    flex: 1;\n    overflow: visible;\n    margin-bottom: 0 !important;\n}\n\n#DropDownContainer {\n    position: absolute;\n    right: 47px;\n    top: 3px;\n    padding-bottom: 2px;\n    background: #1faeff;\n}\n\n#EditButton {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
